import React from "react";
import ContactFormChinese from "../components/ContactFormChinese";
import TopBarChinese from "../components/TopBarChinese";
import ServicesCard from "../components/ServicesCard";
import TeamCard from "../components/TeamCard";
import FooterChinese from "../components/FooterChinese";
import hygeineIcon from "../images/bubbles.png";
import brushIcon from "../images/brush-cleaning.png";
import calendarIcon from "../images/calendar-check.png";
import hamburgerIcon from "../images/hamburger.png";
import heartIcon from "../images/heart-plus.png";
import moonIcon from "../images/moon-star.png";
import shirtIcon from "../images/shirt.png";
import healthcareImage from "../images/senior_hand_hold.jpg";
import elderImage from "../images/elderly-care.jpg";
import "../App.css";

function ServicesChinese() {
   const services = [
  {
    name: "記憶護理服務",
    role: "專為記憶相關疾病人士提供的專業護理。",
    description: [
      "認知刺激活動",
      "記憶練習",
      "安全環境監控",
      "日常維護",
      "徘徊預防",
      "家庭溝通和更新",
      "藥物管理"
    ],
    icon: heartIcon
  },
  {
    name: "衛生護理服務",
    role: "專注於舒適和尊嚴的個人衛生護理。",
    description: [
      "協助淋浴和洗澡",
      "洗髮和護理",
      "口腔衛生協助",
      "足部護理和維護",
      "床上用品更換和護理"
    ],
    icon: hygeineIcon
  },
  {
    name: "美容護理服務",
    role: "幫助您每天都能看起來和感覺最佳。",
    description: [
      "服裝選擇和協調",
      "穿衣協助",
      "髮型設計和修飾",
      "護膚協助"
    ],
    icon: shirtIcon
  },
  {
    name: "餐飲護理服務",
    role: "精心準備的營養餐點，並提供陪伴。",
    description: [
      "個性化餐點規劃",
      "雜貨購物協助",
      "餐點準備與烹飪",
      "用餐協助",
      "自定義烹飪",
      "廚房清理和整理"
    ],
    icon: hamburgerIcon
  },
  {
    name: "健康護理服務",
    role: "支持健康和福祉，提供細心的協助。",
    description: [
      "藥物提醒和監測",
      "藥物組織和管理",
      "詳細的藥物管理記錄",
      "安全的移動協助",
      "物理治療運動支持",
      "醫療約會陪伴"
    ],
    icon: heartIcon
  },
  {
    name: "輕度家務護理服務",
    role: "保持您的家居整潔、安全和舒適。",
    description: [
      "整理床鋪",
      "清潔浴室",
      "掃地和拖地",
      "垃圾和回收管理",
      "處理洗衣",
      "整理郵件、賬單和文件"
    ],
    icon: brushIcon
  },
  {
    name: "全天候護理服務",
    role: "同情心支持日常需求和活動。",
    description: [
      "如廁和個人護理協助",
      "水分監測和支持",
      "定期生命體徵監測",
      "輕柔的運動指導",
      "有趣的活動和遊戲",
      "有意義的對話和陪伴",
      "技術指導和支持",
      "專注的陪伴護理"
    ],
    icon: calendarIcon
  },
  {
    name: "住家 / 夜間護理服務",
    role: "全天候護理以確保安全、舒適和安寧。",
    description: [
      "定期安全監測",
      "營養豐富的小吃準備",
      "小吃和餐點協助",
      "水分管理",
      "健康監測和文檔記錄",
      "安全的夜間移動協助",
      "過夜陪伴",
      "24/7 緊急響應"
    ],
    icon: moonIcon
  },
];

const carePoints = [
  {
    header: "1. 個性化護理計劃",
    subtitle: "我們與您合作制定量身定制的個性化護理計劃，以滿足您的獨特需求。"
  },
  {
    header: "2. 持續監測",
    subtitle: "我們定期跟踪和審查您的護理和服務計劃，以確保最佳結果。"
  },
  {
    header: "3. 全天候支持",
    subtitle: "我們的專業團隊提供 24/7 的協助，以確保安全、舒適和安心。"
  },
  {
    header: "4. 透明的溝通",
    subtitle: "我們與您和您的家人保持開放的對話，以確保清晰和信任。"
  }
];

  return (
    <div className="App">
    <TopBarChinese />
    <div className="App-header-services">
       <div className="hero-text-left">
          <h1 className="hero-title">我們的服務</h1>
          <p className="hero-subtitle-2">
我們的使命是協助您聘請合適的照護人員，讓您的生活每日都更加安全、舒適且充滿意義
。我們用心了解您家庭的獨特需求與關切，並與您密切合作，量身訂做真正符合您狀況的
個人化照護計畫。每位客戶皆會被細心配對到最合適的照護人員，確保雙方的契合度。       
        </p>
        </div>
   
      <div className="service-cards-grid">
        {services.map((service, index) => (
            <ServicesCard
              key={index}
              name={service.name}
              role={service.role}
              services={service.description}
              icon={service.icon}
            />
          ))}
      </div>

     </div>
      <div className="App care-section">
        <div className="Service-2-page">
          <div className="hero-text">
            <h1 className="service-title-2">我們用心呵護您</h1>
            <div className="services-how-we-care-cards">
              {carePoints.map((reasons, index) => (
                <TeamCard
                  key={index}
                  name={reasons.header}
                  description={reasons.subtitle}
                />
              ))}
            </div>
          </div>
          <img src={elderImage} alt="Health care" className="services-image" />
        </div>


      </div>        
  <ContactFormChinese />
  <FooterChinese />
    </div>
  );
}

export default ServicesChinese;
